import { CoffeeCheckIcon, EditNotePenIcon } from "@lhd/assets";
import { CgCoffee } from "react-icons/cg";
import { IoIosPower } from "react-icons/io";
import { IoCheckmark } from "react-icons/io5";
import { LOG_TYPE } from "@lhd/features/TrackingTime/HomeTracking/contants";
import { TimelineItemsConfig } from "./types";

export const TIMELINE_ITEMS: TimelineItemsConfig = {
  note: {
    id: "note",
    background:
      "linear-gradient(90deg, #00F1FF 0%, #00D8FF 23.1%, #00C0FF 51.4%, #00B2FF 77.7%, #00ADFF 100%)",
    icon: <EditNotePenIcon />,
    isNotShowLine: false,
    fields: [{ name: "memo", type: "text", label: "メモ" }],
  },
  [LOG_TYPE.CHECKOUT]: {
    id: "checkout",
    background: "#FC6493",
    icon: <IoIosPower />,
    isNotShowLine: false,
    fields: [
      {
        name: "logged_at",
        type: "time",
      },
      { type: "location", name: "location" },
      { name: "attachments", type: "attachments" },
    ],
  },
  [LOG_TYPE.BREAK_END]: {
    id: "break_end",
    background: "#F67940",
    icon: <CoffeeCheckIcon />,
    isNotShowLine: false,
    fields: [{ name: "logged_at", type: "time", label: "休憩終了" }],
  },
  [LOG_TYPE.BREAK_START]: {
    id: "break_start",
    background: "#FDB73B",
    icon: <CgCoffee />,
    isNotShowLine: false,
    fields: [{ name: "logged_at", type: "time", label: "休憩開始" }],
  },
  [LOG_TYPE.CHECKIN]: {
    id: "checkin",
    background: "#6A8DFF",
    icon: <IoCheckmark />,
    isNotShowLine: false,
    fields: [
      { name: "logged_at", type: "time" },
      { type: "location", name: "location" },
      { name: "attachments", type: "attachments" },
    ],
  },
  [LOG_TYPE.OTHER]: {
    id: "other",
    background: "#999999",
    icon: <EditNotePenIcon />,
    isNotShowLine: false,
    fields: [],
  },
};
